import { render } from "./Urology.vue?vue&type=template&id=74059c1e"
import script from "./Urology.vue?vue&type=script&lang=ts"
export * from "./Urology.vue?vue&type=script&lang=ts"
script.render = render

export default script